import { render, staticRenderFns } from "./TutoModal.vue?vue&type=template&id=5136da9f&scoped=true&"
import script from "./TutoModal.vue?vue&type=script&lang=js&"
export * from "./TutoModal.vue?vue&type=script&lang=js&"
import style0 from "./TutoModal.vue?vue&type=style&index=0&id=5136da9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136da9f",
  null
  
)

export default component.exports